module.exports = __webpack_public_path__ + "img/flk.519e3de5.svg";